import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import { CgPlayStopR } from "react-icons/cg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetFoodItemsForCustomersQuery } from "../slices/FoodItemSilce";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import LazyMemberImage from "../components/LazyMemberImage";

const FoodsListScreen = () => {
  const { foodList } = useSelector((state) => state.foodList);
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: outlets } = useParams();
  const { state } = useLocation();
  // console.log("urlId");
  // console.log(outlets);
  const [searchText, setSearchText] = useState("");
  const [foodItemsToList, setFoodItemsToList] = useState([]);
  const { companyName, deliveryTo } = state || {};
  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  const [foodCategoriesToList, setfoodCategoriesToList] = useState([]);
  const [fullFoodList, setFullFoodList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All Items");

  const {
    data: foodItems,
    isLoading,
    error,
    refetch,
  } = useGetFoodItemsForCustomersQuery({
    query: `outletGroup=${outlets}&currentlySelling=true&itemQuantity[gte]=1`,
  });

  const categoryRefs = useRef({});

  foodCategoriesToList.forEach((cat) => {
    if (!categoryRefs.current[cat]) {
      categoryRefs.current[cat] = React.createRef();
    }
  });

  const scrollToCategory = (category) => {
    if (category === "All" || category === "All Items") {
      // Scroll container to top
      const container = document.querySelector("[style*='overflow-y: auto']");
      if (container) container.scrollTop = 0;
    } else {
      const section = document.getElementById(`section-${category}`);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  useEffect(() => {
    // const timer = setTimeout(() => {
    refetch();
    const items = isLoading ? [] : foodItems ? foodItems : [];
    const foodIds = new Set(foodList.map((f) => f?._id));
    const filterFd = items?.filter((it) => !foodIds.has(it?._id));
    setFoodItemsToList([...filterFd, ...foodList]);
    // }, 500);

    // return () => clearTimeout(timer);
  }, [searchText, isLoading, foodItems, foodList, refetch]);

  useEffect(() => {
    if (!isLoading && foodItems) {
      setFullFoodList(foodItems);
      setFoodItemsToList(foodItems);
      const categories = [
        "All",
        ...new Set(foodItems.map((item) => item.itemCategory).filter(Boolean)),
      ];
      setfoodCategoriesToList(categories);
    }
  }, [isLoading, foodItems]);

  const handleAddButton = (item) => {
    const discountAmount =
      (item.itemOfferPrice * item.discountPercent) / 100 + item.discountAmount;
    const itemDetails = {
      itemId: item._id,
      itemName: item.itemName,
      selectedQuantity: 1,
      itemOfferPrice: item.itemOfferPrice,
      discountAmount: discountAmount,
      itemOriginalPrice: item.itemOriginalPrice,
      gstPercent: userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0,
      totalSellingPrice:
        item.itemOfferPrice -
        discountAmount +
        ((item.itemOfferPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
          100,

      gstTax:
        ((item.itemOfferPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
        100,
    };
    setSelectedItems({ ...selectedItems, [item._id]: itemDetails });
    dispatch(
      setCredentials({
        ...userInfo,
        selectedItems: { ...selectedItems, [item._id]: itemDetails },
      })
    );
    // console.log("selectedItem");
    // console.log(selectedItems);
  };

  const increaseselectedItems = (item) => {
    let getItem = selectedItems[item._id];
    const discountAmount =
      (item.itemOfferPrice * item.discountPercent) / 100 + item.discountAmount;
    const itemDetails = {
      itemId: item._id,
      itemName: item.itemName,
      selectedQuantity: 1 + getItem.selectedQuantity,
      itemOfferPrice: item.itemOfferPrice,
      discountAmount: discountAmount,
      itemOriginalPrice: item.itemOriginalPrice,
      gstPercent: userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0,
      totalSellingPrice:
        (1 + getItem.selectedQuantity) *
          (item.itemOfferPrice - discountAmount) +
        ((1 + getItem.selectedQuantity) *
          (item.itemOfferPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
          100,

      gstTax:
        ((1 + getItem.selectedQuantity) *
          (item.itemOfferPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
        100,
    };
    setSelectedItems({ ...selectedItems, [item._id]: itemDetails });
    dispatch(
      setCredentials({
        ...userInfo,
        selectedItems: { ...selectedItems, [item._id]: itemDetails },
      })
    );
    // console.log("selectedItem");
    // console.log(selectedItems);
  };

  const decreaseselectedItems = (item) => {
    let getItem = selectedItems[item._id];
    const discountAmount =
      (item.itemOfferPrice * item.discountPercent) / 100 + item.discountAmount;
    const itemDetails = {
      itemId: item._id,
      itemName: item.itemName,
      selectedQuantity: getItem.selectedQuantity - 1,
      itemOfferPrice: item.itemOfferPrice,
      discountAmount: discountAmount,
      itemOriginalPrice: item.itemOriginalPrice,
      gstPercent: userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0,
      totalSellingPrice:
        (getItem.selectedQuantity - 1) *
          (item.itemOfferPrice - discountAmount) +
        ((getItem.selectedQuantity - 1) *
          (item.itemOfferPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
          100,

      gstTax:
        ((getItem.selectedQuantity - 1) *
          (item.itemOfferPrice - discountAmount) *
          (userInfo?.outletsDetails[0]?.separateGst ? item.gstTax : 0)) /
        100,
    };
    console.log("itemDetails");
    console.log(itemDetails);
    if (itemDetails.selectedQuantity < 1) {
      const abb = delete selectedItems[item._id];
      setSelectedItems({ ...selectedItems });
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: { ...selectedItems },
        })
      );
    } else {
      setSelectedItems({ ...selectedItems, [item._id]: itemDetails });
      dispatch(
        setCredentials({
          ...userInfo,
          selectedItems: { ...selectedItems, [item._id]: itemDetails },
        })
      );
    }
  };

  // const totalItems = selectedItems?.reduce((sum, qty) => sum + qty, 0);
  // const totalPrice = selectedItems?.reduce(
  //   (sum, qty, i) => sum + qty * foodItemsToList[i]?.itemOfferPrice,
  //   0
  // );

  const filteredFoods = foodItemsToList.filter((item) => {
    const name = item?.itemName?.toLowerCase() || "";
    const local = item?.localName?.toLowerCase() || "";
    const matchesSearch =
      name.includes(searchText.toLowerCase()) ||
      local.includes(searchText.toLowerCase());

    const matchesCategory =
      selectedCategory === "All" || selectedCategory === "All Items"
        ? true
        : item.itemCategory === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  const foodsGroupedByCategory = {};
  filteredFoods.forEach((item) => {
    const cat = item.itemCategory || "Uncategorized";
    if (!foodsGroupedByCategory[cat]) foodsGroupedByCategory[cat] = [];
    foodsGroupedByCategory[cat].push(item);
  });

  const handleContinueButton = () => {
    dispatch(setCredentials({ ...userInfo, selectedItems: selectedItems }));
    navigate("/bookingSummary");
  };

  return (
    <>
      {" "}
      <FaArrowLeft
        style={{
          color: "green",
          marginRight: "1rem",
          fontSize: "1.8rem",
        }}
        onClick={() => navigate(-1)}
      />
      {/* <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h4 style={{ color: "black" }}>{companyName} </h4>
      </div> */}
      <Row
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
          width: "70%",
          margin: "auto",
          textAlign: "center",
          // marginTop: "1rem",
          color: "black",
        }}
      >
        <Col style={{ color: "black" }}>
          <div className="home-heading">
            {/* <h1>{companyName}</h1> */}
            {!deliveryTo?.includes("undefined") && <p>Seat - {deliveryTo}</p>}
          </div>
        </Col>
        <Form.Control
          style={{
            height: "2.5rem",
            fontSize: "16px", // 👈 This prevents iOS zoom
          }}
          type="text"
          value={searchText}
          onChange={(e) => {
            const value = e.target.value;
            const txt = value.replace(/[^a-zA-Z\s]/g, "");
            setSearchText(txt);
          }}
          placeholder="Search by Food Name"
        />
        {/* <Col className="food-category-scroll">
          {foodCategoriesToList.map((cat) => (
            <Button
              key={cat}
              variant={
                selectedCategory === cat ? "primary" : "outline-secondary"
              }
              className="rounded-pill px-4 py-1 me-2"
              size="sm"
              onClick={() => setSelectedCategory(cat)}
            >
              {cat}
            </Button>
          ))}
        </Col> */}
      </Row>
      <Row
        className="food-group-scroll"
        style={{
          marginTop: "0.7rem",
          marginBottom: "0.5rem",
          overflowX: "auto",
          whiteSpace: "nowrap",
          width: "96%",
        }}
      >
        <div>
          {foodCategoriesToList.map((cat) => (
            <Button
              style={{
                fontSize: "1rem",
                backgroundColor: "transparent",
                color: "green",
                margin: "0.4rem",
                border: "solid 1px grey",
                borderRadius: "0.5rem",
              }}
              key={`scroll-btn-${cat}`}
              size="md"
              onClick={() => scrollToCategory(cat)}
            >
              {cat}
            </Button>
          ))}
        </div>
      </Row>
      <hr />
      {searchText?.length > 0 && (
        <h6 style={{ color: "red" }}>you are seeing searched foods now</h6>
      )}
      <div
        style={{
          height: "60vh",
          overflowY: "auto",
          padding: "0rem 0.5rem",
        }}
      >
        {Object.entries(foodsGroupedByCategory).map(([category, items]) => (
          <div key={category} id={`section-${category}`}>
            <h5
              style={{
                color: "#555",
                marginTop: "0.1rem",
                textDecorationLine: "underline",
              }}
            >
              {category}
            </h5>

            {items.map((ff) => (
              <Row
                key={ff._id}
                className="align-items-center mb-3"
                style={{
                  borderBottom: "1px solid #ddd",
                  paddingBottom: "0.8rem",
                }}
              >
                {/* Food Image */}
                <Col xs={3}>
                  <LazyMemberImage
                    foodItemId={ff._id}
                    imageUpdatedTimeFromDB={ff.imageUploadedTime}
                    currentlySelling={ff.currentlySelling}
                    photoUploaded={ff.imageUploaded}
                  />
                </Col>

                {/* Name & Price */}
                <Col xs={5}>
                  <div style={{ fontWeight: "bold" }}>
                    {ff.itemName}{" "}
                    {ff.isVeg ? (
                      <CgPlayStopR
                        style={{ color: "green", width: "0.6rem" }}
                      />
                    ) : (
                      <CgPlayStopR style={{ color: "red", width: "0.6rem" }} />
                    )}
                  </div>
                  <div style={{ color: "gray", fontSize: "0.9rem" }}>
                    {ff.localName}
                  </div>
                  <br />
                  <span style={{ marginTop: "0.1rem", fontWeight: "500" }}>
                    <span
                      style={{
                        textDecoration: "line-through",
                        marginRight: "0.2rem",
                      }}
                    >
                      ₹{ff.itemOriginalPrice}
                    </span>
                    <span>
                      ₹
                      {ff.itemOfferPrice -
                        (ff.itemOfferPrice * ff.discountPercent) / 100 -
                        ff.discountAmount}
                    </span>{" "}
                    {ff.itemQuantity < 10 && (
                      <small style={{ color: "red" }}>
                        only {ff.itemQuantity} left
                      </small>
                    )}
                  </span>
                </Col>

                {/* Quantity Controls */}
                <Col
                  xs={4}
                  className="d-flex align-items-center justify-content-end"
                >
                  {selectedItems[ff._id]?.selectedQuantity > 0 ? (
                    <div
                      className="d-flex align-items-center"
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "0.5rem",
                        padding: "0.2rem 0.5rem",
                        backgroundColor: "green",
                        color: "white",
                        fontSize: "1.1rem",
                      }}
                    >
                      <span
                        style={{ margin: "5px 10px", fontSize: "1.8rem" }}
                        onClick={() => decreaseselectedItems(ff)}
                      >
                        <strong>-</strong>
                      </span>
                      <span style={{ margin: "0 0.5rem" }}>
                        <strong>
                          {selectedItems[ff._id]?.selectedQuantity}
                        </strong>
                      </span>
                      <span
                        style={{ margin: "5px 10px", fontSize: "1.8rem" }}
                        onClick={() =>
                          selectedItems[ff._id].selectedQuantity <
                            ff.itemQuantity && increaseselectedItems(ff)
                        }
                      >
                        <strong>+</strong>
                      </span>
                    </div>
                  ) : (
                    <Button
                      disabled={ff.itemQuantity <= 0}
                      style={{
                        width: "5rem",
                        height: "2.5rem",
                        fontSize: "1rem",
                      }}
                      onClick={() => handleAddButton(ff)}
                    >
                      Add
                    </Button>
                  )}
                </Col>
              </Row>
            ))}
          </div>
        ))}
      </div>
      <hr />
      <Row className="align-items-center">
        <Col>
          <span style={{ color: "green" }}>Foot Items in Cart</span>
          <br />
          <br />
          <strong style={{ fontSize: "1.2rem" }}>
            Total ₹
            {selectedItems &&
              Object.values(selectedItems)?.reduce(
                (total, it) =>
                  total +
                  (Number(it.itemOfferPrice) - Number(it.discountAmount)) *
                    it.selectedQuantity,
                0
              )}{" "}
            |{" "}
            {selectedItems &&
              Object.values(selectedItems)?.reduce(
                (total, it) => total + Number(it.selectedQuantity),
                0
              )}{" "}
            Items{" "}
          </strong>{" "}
        </Col>
        <Col xs="auto">
          <Button
            disabled={selectedItems && Object.values(selectedItems)?.length < 1}
            style={{
              fontSize: "1rem",
              padding: "0.8rem",
              backgroundColor: "orange",
              color: "black",
            }}
            className="continue-btn"
            onClick={(e) => handleContinueButton()}
          >
            <strong>CONTINUE</strong>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default FoodsListScreen;
